import { host, getSessionToken, authenticatedFetch } from './appbridge'
import { baseAPIUrl } from './globals'
import { lang } from './store/store'
import { writable, get, set } from 'svelte/store'
import {
  collectionGroup,
  collection,
  query,
  where,
  getDocs
} from 'firebase/firestore'
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { User } from './classes/user'
import {
  getAuth,
  signInWithCustomToken,
  onAuthStateChanged,
  signOut
} from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage, ref } from 'firebase/storage'
import { router } from 'tinro';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: process.env['FIREBASE_APP_API_KEY'],
  authDomain: process.env['FIREBASE_APP_AUTH_DOMAIN'],
  projectId: process.env['FIREBASE_APP_PROJECT_ID'],
  storageBucket: process.env['FIREBASE_APP_STORAGE_BUCKET'],
  messagingSenderId: process.env['FIREBASE_APP_MESSAGING_SENDER_ID'],
  appId: process.env['FIREBASE_APP_ID']
}
// Initialize Firebase
export const user = writable(undefined)
const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
console.log('doing init user')

if (host) {
  authenticatedFetch(baseAPIUrl + '/initUser').then(async resp => {
    console.log('got response')
    const payload = JSON.parse(await resp.text())
    console.log({ payload })
    if (!payload.success) {
      return
    }
    signInWithCustomToken(auth, payload.token)
      .then(userCredential => {
        console.log({ userCredential })
      })
      .catch(error => {
        console.log({ error })
      })
    console.log(auth.currentUser)
  })
}

onAuthStateChanged(auth, async luser => {
  console.log('f***************************')
  console.log(luser)
  if (luser) {
    
    luser.claims = (await luser.getIdTokenResult()).claims
    console.log(luser.claims)
    if (luser.claims.admin){
      console.log(luser.claims)
      const urlParams = new URLSearchParams(window.location.search);
      const domain = urlParams.get("domain")
      if (domain) {
        luser.claims.store = domain
      }
    }
    console.log("CLAIMS")
    console.log({claims: luser.claims?.store})
    console.log("store: " + luser?.claims?.store )
    if (!luser?.claims?.store) {
      console.log("NO STORE CLAIM")
      luser.claims.store = luser.displayName
    }
    let classedUser = await new User(luser)
    const { doc } = classedUser
    user.set(classedUser)
    user.auth = luser
    
    try {
      lang.set(get(doc).account.locale)
    } catch (error) {
      
    }

    /* remove spinner */
    if (document.querySelector('.u-spinner-area-global')) {
      document.querySelector('.u-spinner-area-global').remove()
    }
  } else {
    if (host) {
      user.set(undefined)
    } else {
      user.set(null)
      /* remove spinner */
      if (document.querySelector('.u-spinner-area-global')) {
        document.querySelector('.u-spinner-area-global').remove()
      }
    }
  }
})
